export const Departments = [
  {
    key: '0',
    label: 'РТК',
    icon: 'pi pi-fw pi-inbox',
    children: [
      {
        key: '0-0',
        label: 'НФТС ЮГ',
        icon: 'pi pi-fw pi-cog',
        children: [
          {
            key: '0-0-0',
            label: 'Фил Ставропольск',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-0-1',
            label: 'Фил Сев-Осетинск',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-0-2',
            label: 'Фил Ростовский',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-0-3',
            label: 'Фил Краснодарск',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-0-4',
            label: 'Фил Калмыцкий',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-0-5',
            label: 'Фил Каб-Балкарск',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-0-6',
            label: 'Фил Ингушский',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-0-7',
            label: 'Фил Дагестанский',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-0-8',
            label: 'Фил Волгоградск',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-0-9',
            label: 'Фил Астраханский',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-0-10',
            label: 'ОУСС',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-0-11',
            label: 'ОМСС',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-0-12',
            label: 'НТМСиРС Юг',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-0-13',
            label: 'Инвентарная СУРТС',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-0-14',
            label: 'ДРОС Юг',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-0-15',
            label: 'ГУТС (МРФ ЮГ)',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          }
        ],
        data: 'Подразделение'
      },
      {
        key: '0-1',
        label: 'НФТС Центр',
        icon: 'pi pi-fw pi-cog',
        children: [
          {
            key: '0-1-0',
            label: 'Фил Ярос и Костр',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-1-1',
            label: 'Фил Тверской',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-1-2',
            label: 'Фил Тамбовск',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-1-3',
            label: 'Фил Смоленский',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-1-4',
            label: 'Фил Липецкий',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-1-5',
            label: 'Фил Курский',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-1-6',
            label: 'Фил Калужский',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-1-7',
            label: 'Фил Воронежский',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-1-8',
            label: 'Фил Влад и Иван',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-1-9',
            label: 'Фил Брянск и Орл',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-1-10',
            label: 'Фил Белгородский',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-1-11',
            label: 'ТЦТЭТ Западный',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-1-12',
            label: 'ТЦТЭТ Восточный',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-1-13',
            label: 'НТМиРС Центр',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-1-14',
            label: 'МОУТЭ',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-1-15',
            label: 'МГУТЭ',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-1-16',
            label: 'Инвентарная СУРТС',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-1-17',
            label: 'ДРОС',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-1-18',
            label: ' Дирекция',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          }
        ],
        data: 'Подразделение'
      },
      {
        key: '0-2',
        label: 'НФТС Урал',
        icon: 'pi pi-fw pi-cog',
        children: [
          {
            key: '0-2-0',
            label: 'Фил Ямало-Ненец',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-2-1',
            label: 'Фил Челябинский',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-2-2',
            label: 'Фил Ханты-Манс',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-2-3',
            label: 'Фил Тюм и Курган',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-2-4',
            label: 'Фил Пермский',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-2-5',
            label: 'Фил Екатеринбург',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-2-6',
            label: 'НТМиРС_Тупицын',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-2-7',
            label: 'НТМиРС_Суханюк',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-2-8',
            label: 'НТМиРС_Суханова',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-2-9',
            label: 'НТМиРС_Соколова',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-2-10',
            label: 'НТМиРС_Скударнов',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-2-11',
            label: 'НТМиРС_Синицын',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-2-12',
            label: 'НТМиРС_Садыков',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-2-13',
            label: 'НТМиРС_Подвашецкий ',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-2-14',
            label: 'НТМиРС_Осипова',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-2-15',
            label: 'НТМиРС_Нечаев',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-2-16',
            label: 'НТМиРС_Насонов',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-2-17',
            label: 'НТМиРС_Кудрина',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-2-18',
            label: 'НТМиРС_Коновалов',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-2-19',
            label: 'НТМиРС_Зиновьев',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-2-20',
            label: 'НТМиРС_Зеленин',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-2-21',
            label: 'НТМиРС_Дружков',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-2-22',
            label: 'НТМиРС_Григорьев',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-2-23',
            label: 'НТМиРС_Беляев',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-2-24',
            label: 'НТМиРС_Афонасенко',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-2-25',
            label: 'Инвентарная СУРТС',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-2-26',
            label: 'ДРОС Урал',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          }
        ],
        data: 'Подразделение'
      },
      {
        key: '0-3',
        label: 'НФТС Сибирь',
        icon: 'pi pi-fw pi-cog',
        children: [
          {
            key: '0-3-0',
            label: 'Фил Томский',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-3-1',
            label: 'Фил Омский',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-3-2',
            label: 'Фил Новосибирск',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-3-3',
            label: 'Фил Красноярский',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-3-4',
            label: 'Фил Кемеровский',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-3-5',
            label: 'Фил Иркутский',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-3-6',
            label: 'Фил Бурятский',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-3-7',
            label: 'Фил Алтайский',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-3-8',
            label: 'НТМиРС_Скорик',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-3-9',
            label: 'НТМиРС_Пронина',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-3-10',
            label: 'НТМиРС_Назаров',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-3-11',
            label: 'НТМиРС_Казанцев',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-3-12',
            label: 'НТМиРС_Иванцов',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-3-13',
            label: 'НТМиРС_Дурова',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-3-14',
            label: 'НТМиРС_Гавриленко',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-3-15',
            label: 'НТМиРС_Волобуев',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-3-16',
            label: 'НТМиРС_Борисов',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-3-17',
            label: 'Инвентарная СУРТС',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-3-18',
            label: 'ДРОС Сибирь',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-3-19',
            label: ' Дирекция',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          }
        ],
        data: 'Подразделение'
      },
      {
        key: '0-4',
        label: 'НФТС Северо-Запад',
        icon: 'pi pi-fw pi-cog',
        children: [
          {
            key: '0-4-0',
            label: 'Фил Новг и Псков',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-4-1',
            label: 'Фил Мурманск',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-4-2',
            label: 'Фил Коми',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-4-3',
            label: 'Фил Карельский',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-4-4',
            label: 'Фил Калининград',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-4-5',
            label: 'Фил Вологодский',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-4-6',
            label: 'Фил Архангельск',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-4-7',
            label: 'НФТС',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-4-8',
            label: 'НТУМС Новгородский филиал',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-4-9',
            label: 'НТУМС Вологодский филиал',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-4-10',
            label: 'Инвентарная СУРТС',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-4-11',
            label: 'ДЭТИ',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          }
        ],
        data: 'Подразделение'
      },
      {
        key: '0-5',
        label: 'НФТС Дальний Восток',
        icon: 'pi pi-fw pi-cog',
        children: [
          {
            key: '0-5-0',
            label: 'Фил Хабаровский',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-5-1',
            label: 'Фил Сахателеком',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-5-2',
            label: 'Фил Сахалинский',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-5-3',
            label: 'Фил Приморский',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-5-4',
            label: 'Фил Магаданский',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-5-5',
            label: 'Фил Камчатский',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-5-6',
            label: 'Фил Амурский',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-5-7',
            label: 'НТУМС Дальний Восток',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-5-8',
            label: 'НТМиРС_Щербакова',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-5-9',
            label: 'НТМиРС_Шокуров',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-5-10',
            label: 'НТМиРС_Свечкова',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-5-11',
            label: 'НТМиРС_Ревенок',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-5-12',
            label: 'НТМиРС_Макарова',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-5-13',
            label: 'НТМиРС_Ворожейкина',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-5-14',
            label: 'НТМиРС_Владимиров',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-5-15',
            label: 'Инвентарная СУРТС',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-5-16',
            label: 'ДРОС ДВ',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          }
        ],
        data: 'Подразделение'
      },
      {
        key: '0-6',
        label: 'НФТС Волга',
        icon: 'pi pi-fw pi-cog',
        children: [
          {
            key: '0-6-0',
            label: 'Филиал в республике Татарстан',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-6-1',
            label: 'Фил Ульяновский',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-6-2',
            label: 'Схемы (МРФ Волга)',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-6-3',
            label: 'Самарский филиал',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-6-4',
            label: 'Пензенский филиал',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-6-5',
            label: 'Оренбургский филиал',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-6-6',
            label: 'ОАУиФС ЦБД',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-6-7',
            label: 'НТМиРС_Старков ВА',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-6-8',
            label: 'НТМиРС_Серебренников ВВ',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-6-9',
            label: 'НТМиРС_Семёнов СИ',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-6-10',
            label: 'НТМиРС_Самойлов ЕК',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-6-11',
            label: 'НТМиРС_Орлов ДВ',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-6-12',
            label: 'НТМиРС_Мухамадиев ЗР',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-6-13',
            label: 'НТМиРС_Махмудов РМ',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-6-14',
            label: 'НТМиРС_Максумов АР',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-6-15',
            label: 'НТМиРС_Куракин МС',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-6-16',
            label: 'НТМиРС_Коннов ПА',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-6-17',
            label: 'НТМиРС_Зубов АВ',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-6-18',
            label: 'НТМиРС_Григорьева РБ',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-6-19',
            label: 'НТМиРС_Гильмутдинов РР',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-6-20',
            label: 'НТМиРС_Бойцов АО',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-6-21',
            label: 'НТМиРС_Абрамова НВ',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-6-22',
            label: 'МордовияРФ',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-6-23',
            label: 'Кировский филиал',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-6-24',
            label: 'Инвентарная СУРТС',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-6-25',
            label: 'ГУТС (МРФ Волга)',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          }
        ],
        data: 'Подразделение'
      },
      {
        key: '0-7',
        label: 'КЦ',
        icon: 'pi pi-fw pi-cog',
        children: [
          {
            key: '0-7-0',
            label: 'ТЦКПМТ МРФ Центр',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-7-1',
            label: 'ПРСГП',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-7-2',
            label: 'ОПМС ДПС',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-7-3',
            label: 'ОПИГИС',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-7-4',
            label: 'Опер.Дежурный',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-7-5',
            label: 'ОАФУIPССКП ДАФУ',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-7-6',
            label: 'ОАТС ДАСС',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-7-7',
            label: 'НФТС УФС',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-7-8',
            label: 'НФТС Нумерация и ГОЗ',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-7-9',
            label: 'НФСК ОКС7',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-7-10',
            label: 'НПСиТС ТЛГ',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-7-11',
            label: 'НПСиТС ПС',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-7-12',
            label: 'НМТС Запад СГМД Смена',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-7-13',
            label: 'НМТС Запад СГМД',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-7-14',
            label: 'НМТС Запад',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-7-15',
            label: 'НМТС Восток',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-7-16',
            label: 'ДУВС',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-7-17',
            label: 'ДРС',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-7-18',
            label: 'ДРОС',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-7-19',
            label: 'Блок МВ',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          },
          {
            key: '0-7-20',
            label: ' ДИИГС',
            icon: 'pi pi-fw pi-file',
            data: 'Участок'
          }
        ],
        data: 'Подразделение'
      }
    ],
    data: 'Родитель 1'
  }
];
